import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import isEqual from 'lodash/fp/isEqual';
import classNames from 'classnames';
import Collapse from '../collapse/Collapse';
import { hasBorderClass, hasRoundedClass } from '../../utils/hasUtilityClass';
const getRandomString = () => (Math.random() + 1).toString(36).toUpperCase().substring(2);
// Generate a unique id (if not present) instead of using the index for the key as it will create
// side effects when removing items from the list and re-render the ExpanderList.
const parseItems = (items) => {
    return items.map(item => {
        if (!item.id) {
            item.id = getRandomString();
        }
        return item;
    });
};
const ExpanderList = (props) => {
    const { items = [], unmountOnExit = true, rounded = true, bordered = true, className = '' } = props;
    const [listItems, setListItems] = useState(parseItems(items));
    // Update internal state from external prop change
    const [previousItems, setPreviousItems] = useState(items);
    if (!isEqual(previousItems, items)) {
        setListItems(parseItems(items));
        setPreviousItems(items);
    }
    const handleToggleItem = (itemToExpand) => {
        if (!itemToExpand.body) {
            return;
        }
        // Toggle the open state for the selected item based on the provided or generated id
        const updatedListItems = [...listItems].map(item => {
            if (item.id === itemToExpand.id) {
                item.onOpen && !item.open && item.onOpen();
                item.onClose && item.open && item.onClose();
                item.open = !item.open;
            }
            return item;
        });
        setListItems(updatedListItems);
    };
    const listClassNames = classNames('expander-list list-group', rounded && !hasRoundedClass(className) && 'rounded', bordered && !hasBorderClass(className) && 'border', className);
    return (_jsx("ul", Object.assign({ className: listClassNames }, { children: listItems.map(item => {
            const isOpen = item.open;
            const itemClassNames = classNames('list-group-item', item.className && item.className, item.body && 'expandable', isOpen && 'open');
            return (_jsxs("li", Object.assign({ className: itemClassNames }, { children: [_jsx(ExpanderListItemHeader, { item: item, onToggle: handleToggleItem }), item.body && (_jsx(Collapse, Object.assign({ open: isOpen, unmountOnExit: unmountOnExit }, { children: _jsx("div", Object.assign({ className: 'expander-list-body-wrapper' }, { children: _jsx(ExpanderListItemBody, Object.assign({ className: item.bodyClassName }, { children: item.body })) })) })))] }), item.id));
        }) })));
};
const ExpanderListItemHeader = ({ item, onToggle }) => {
    const headerClassNames = classNames('expander-list-header', item.headerClassName);
    const iconClassNames = classNames('expander-icon', 'rioglyph', 'rioglyph-chevron-down');
    return (_jsxs("div", Object.assign({ className: headerClassNames, onClick: () => onToggle(item), "aria-label": 'expander item header' }, { children: [_jsx("span", Object.assign({ className: 'expander-list-header-content' }, { children: item.header })), item.body && _jsx("span", { className: iconClassNames })] })));
};
const ExpanderListItemBody = ({ className, children }) => {
    const bodyClassNames = classNames('expander-list-body', className);
    return (_jsx("div", Object.assign({ className: bodyClassNames, "aria-label": 'expander item body' }, { children: children })));
};
export default ExpanderList;
